"use strict";

define('components/filter_bar/filters/location_filters',[], function() {
    var locationFiltersComponent = {
        initWithContext: function(context) {
            // TODO: This component's DOM queries
            // should be scoped to context.containerNode
            // Need to check DOM placement of #show-ext-filters

            _initData(context);
            _initAutocomplete(context);

            var revealer = context.locationFiltersData.revealer;
            revealer.click(function(e) {
                if (!context.hasFilter('location_string')) {
                    revealer.toggleClass('btn-info')
                            .toggleClass('selected');
                }
                context.locationFiltersData.locationFilters.toggleClass('hidden');
            });
        },
        
        resetToDefaultUI: function(context) {
            context.locationFiltersData.revealer.removeClass('btn-info')
                                                .removeClass('selected');

            context.locationFiltersData.locationFilters.addClass('hidden');
            context.locationFiltersData.showIfLocationActiveNode.addClass('hidden');
        }
    };

    function _initData(context) {
        context.locationFiltersData = {
            autocompleteInstance: null,
            clearSearchLink: $('#clear-location-search-link'),
            locationFilters: $('#location-filters'),
            locationSearchBar: $('#location-search-bar'),
            radiusInput: $('#location-radius-input'),
            radiusInputGroup: $('.radius-input-group'),
            radiusNA: $('#location-radius-na'),
            revealer: $('#show-location-filters'),
            showIfLocationActiveNode: $('.show-if-location-active')
        };
    }

    function _initAutocomplete(context) {
        // Initialize location autocomplete
        var locationSearchBar = context.locationFiltersData.locationSearchBar;
        if (!locationSearchBar[0]) return;

        // TODO: Probably need to first insure google API is ready
        var config = {
            types: ['geocode']
        };
        context.locationFiltersData.autocompleteInstance = new google.maps.places.Autocomplete(locationSearchBar[0], config);

        var autocompleteInstance = context.locationFiltersData.autocompleteInstance;

        autocompleteInstance.addListener('place_changed', function() {
            _handleLocationSearch(context);
        });

        var radiusInput = context.locationFiltersData.radiusInput;
        var locationFilters = context.locationFiltersData.locationFilters;

        if (radiusInput.val() == '') {
            radiusInput.val(locationFilters.data('default-radius'));
        }

        radiusInput.blur(function() {
            var radius = radiusInput.val();
            if (radius <= 0) {
                radius = locationFilters.data('default-radius');
                radiusInput.val(radius);
            }

            var locationStr = context.getFilter('location_string');
            var lat = context.getFilter('lat');
            var lng = context.getFilter('lng');
            _setLocationFilters(context, 'r' + radius, locationStr, lat, lng);
        });

        radiusInput.on('keyup', function(e) {
            if (e.keyCode == 13) {
                radiusInput.blur();
            }
        });

        context.locationFiltersData.clearSearchLink.on('click', function(e) {
            e.preventDefault();

            _setLocationFilters(context);
            locationSearchBar.removeClass('bad-input');
        });

        locationSearchBar.blur(function(e) {
            var value = locationSearchBar.val().trim();

            var place = autocompleteInstance.getPlace();
            if (place !== undefined) {
                if (value === place.formatted_address) {
                    return;
                } else {
                    _indicateBadLocation(context);
                    return false;
                }
            } else {
                var locationStr = context.getFilter('location_string');
                if (locationStr && locationStr[0] === value) {
                    return;
                } else {
                    _indicateBadLocation(context);
                    return false;
                }
            }
        });
    }

    function _handleLocationSearch(context) {
        var locationFilters = context.locationFiltersData.locationFilters;
        var radiusInput = context.locationFiltersData.radiusInput;

        var place = context.locationFiltersData.autocompleteInstance.getPlace();
        if (typeof place.geometry == 'undefined') {
            _indicateBadLocation(context);
            return false;
        } else {
            var address = place.formatted_address;
            var placeType = place.types[0];
            if (placeType == "country") {
                var countries = locationFilters.data('countries');
                if (address in countries) {
                    var country_id = countries[address];
                    _setLocationFilters(context, 'c' + country_id, address);
                    return;
                }
                // Country was not found in list. Return no results.
                _setLocationFilters(context, 'c-1', address);
                return;
            } else if (placeType == 'administrative_area_level_1' && address.slice(-3) == 'USA') {
                var state = address.slice(null, -5);
                var states = locationFilters.data('states');
                if (state in states) {
                    var state_id = states[state];
                    _setLocationFilters(context, 's' + state_id, address);
                    return;
                }
                // State was not found in list return no results
                _setLocationFilters(context, 's-1', address);
                return;
            } else {
                // Do a radius search
                var lat = place.geometry.location.lat();
                var lng = place.geometry.location.lng();
                var radius = radiusInput.val();
                if (radius == '' || radius <= 0) {
                    radius = locationFilters.data('default-radius');
                }
                _setLocationFilters(context, 'r' + radius, address, lat, lng);
            }
        }
    }

    function _indicateBadLocation(context) {
        context.locationFiltersData.locationSearchBar.addClass('bad-input');
        context.locationFiltersData.radiusInputGroup.addClass('hidden');
        context.locationFiltersData.radiusNA.removeClass('hidden');
        context.locationFiltersData.radiusNA.find('> [data-toggle="popover"]').addClass('hidden');
    }

    function _setLocationFilters(context, locationFilter, locationString, lat, lng) {
        context.removeFilter('location');
        context.removeFilter('location_string');
        context.removeFilter('lat');
        context.removeFilter('lng');

        var hide_location_search = true;

        if (locationFilter !== undefined) {
            context.applyFilter('location', locationFilter);

            if (locationFilter[0] == 'r') {
                context.locationFiltersData.radiusInputGroup.removeClass('hidden');
                context.locationFiltersData.radiusInput.val(locationFilter.slice(1));
                context.locationFiltersData.radiusNA.addClass('hidden');
            } else {
                context.locationFiltersData.radiusInputGroup.addClass('hidden');
                context.locationFiltersData.radiusNA.removeClass('hidden');
                context.locationFiltersData.radiusNA.find('> [data-toggle="popover"]').removeClass('hidden');
            }
            hide_location_search = false;
        }

        if (locationString !== undefined) {
            context.applyFilter('location_string', locationString);
            context.locationFiltersData.locationSearchBar.val(locationString);
            hide_location_search = false;
        }

        if (lat !== undefined) {
            context.applyFilter('lat', lat);
            hide_location_search = false;
        }

        if (lng !== undefined) {
            context.applyFilter('lng', lng);
            hide_location_search = false;
        }

        if (hide_location_search) {
            context.locationFiltersData.revealer.click();
            context.locationFiltersData.showIfLocationActiveNode.addClass('hidden');
        } else {
            context.locationFiltersData.showIfLocationActiveNode.removeClass('hidden');
        }

        context.locationFiltersData.locationSearchBar.removeClass('bad-input');

        context.markDirtyState();
    }

    return locationFiltersComponent;
});

